var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('number-input',{staticClass:"send-message-typing-action w-full mb-0 mt-0",attrs:{"setup":{
    func: _vm.typingTimeChange,
    args: {
      model: _vm.action.action,
      key: 'time',
      prefix: 'send_message_typing_',
      min: 1,
      max: 30,
      inline: true,
    }
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }